import makeUrl from './makeUrl/makeUrl'
import useModule from '../../hooks/useModule'
import {
  CONTROLLER,
  MONITOR,
  MONITOR_CONFIG,
  TEST_CONFIG
} from '../routes'
import { Hyperlink } from '@eggplant/pattern-library'
import type { Props } from '../types'

interface Params {
  testConfigId: string
  tab?: 0 | 1 | 2
  configType?: string
}

const LinkToEditTestConfigHyperlink = ({
  children,
  testConfigId,
  tab,
  configType
}: (Props & Params)) => {
  const [isMonitorFlag] = useModule()

  const base = configType === 'monitor' || isMonitorFlag
    ? '/' + MONITOR + '/' + MONITOR_CONFIG + '/' + testConfigId
    : '/' + CONTROLLER + '/' + TEST_CONFIG + '/' + testConfigId

  const tabQueryParam = { tab }

  const url = tab
    ? makeUrl(base, tabQueryParam)
    : base

  return (
    <Hyperlink
      href={url}
      isExternal
    >
      {children}
    </Hyperlink>
  )
}

export default LinkToEditTestConfigHyperlink
